import Styleguide from "@store/Framework/Types/Styleguide";

// "Build" rules are only applied if the value was not altered in the blueprint
const breakpoints: Styleguide["breakpoints"] = {
    values: [0, 600, 900, 1200, -1], // Build: Last value becomes "siteWidth"
    maxWidths: [-1, -1, -1, -1, -1], // Build: Set to the largest "breakpoints.values"
};

export default breakpoints;
